<template>
  <div class="space-y-3">
    <div class="grid grid-cols-1 md:flex md:justify-between items-center gap-4">
      <div class="grid grid-cols-2 gap-4">
        <Button v-if="false" label="Bill" outlined severity="info" @click="$emit('print', 'bill-print')" />
        <Button label="Checker" outlined severity="info"
          @click="$emit('printchecker', { items: sortedOrderItems, isTransaction: true })" />
        <div v-if="sortedOrderItems.length > 0" class="flex items-center gap-2">
          <label for="Complimentary" class="text-xs">Complimentary All</label>
          <ToggleSwitch v-model="localComplimentaryAll" id="Complimentary" class="h-4 w-8"
            @change="handleComplimentaryToggle">
            <template #handle="{ checked }">
              <i :class="['!text-xs pi', { 'pi-check': checked, 'pi-times': !checked }]" />
            </template>
          </ToggleSwitch>
        </div>
      </div>
    </div>
    <div v-for="item in sortedOrderItems" :key="item.id" :class="[
      'relative transform transition-all duration-200 hover:shadow-lg mr-2',
      item.payment_status == 2
        ? 'bg-gray-200 dark:bg-dark-800'
        : 'bg-gray-100 dark:bg-dark-700',
    ]" class="rounded-xl px-2 py-1 border border-gray-200 dark:border-dark-700">
      <!-- Product Info -->
      <div class="flex flex-col">
        <!-- Header with Status -->
        <div class="flex flex-col items-start gap-2">
          <!-- Status Badges -->
          <div class="flex flex-wrap justify-between gap-2 w-full">
            <div class="flex flex-wrap gap-2">
              <div v-if="item.status === 'pending'"
                class="text-xs px-2 py-1 rounded-full bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-100 text-center whitespace-nowrap">
                {{
                  item.createdAt
                    ? "Order " + formatTime(item.createdAt, "time")
                    : "Sudah dipesan"
                }}
              </div>
              <div v-if="item.status === 'canceled'"
                class="text-xs px-2 py-1 rounded-full bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-100 text-center whitespace-nowrap">
                Cancel {{ item.createdAt ? formatTime(item.createdAt, "time") : "" }}
              </div>
              <!-- <div v-else-if="item.status === 'pending'"
              class="text-xs px-2 py-1 rounded-full bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-100 text-center whitespace-nowrap">
              Sudah dipesan
            </div> -->
              <div v-else-if="item.status === 'delivered'"
                class="text-xs px-2 py-1 rounded-full bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-100 text-center whitespace-nowrap">
                Sudah diantar
              </div>
              <div v-if="item.status === 'unsaved'"
                class="text-xs px-2 py-1 rounded-full bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-100 text-center whitespace-nowrap">
                Belum dipesan
              </div>
              <span v-if="item.complimentary" for="Complimentary"
                class="text-xs px-2 py-1 rounded-full bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-100 text-center whitespace-nowrap">
                Complimentary</span>
            </div>

            <div class="flex flex-wrap gap-2">
              <button @click="confirmPrint('kitchen', item)"
                :class="[item?.is_print_kitchen ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-100 hover:bg-green-200 border border-green-800 dark:border-green-100 border-b-2' : 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-100 hover:bg-yellow-200 border border-yellow-800 dark:border-yellow-100 border-b-2']"
                class="text-xs px-2 py-1 rounded-full text-center whitespace-nowrap flex items-center gap-1 transition-colors">
                <PrinterIcon class="w-4 h-4" />
                <span>Kitchen</span>
              </button>
              <button @click="confirmPrint('checker', item)"
                :class="[item?.is_print_checker ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-100 hover:bg-green-200 border border-green-800 dark:border-green-100 border-b-2' : 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-100 hover:bg-yellow-200 border border-yellow-800 dark:border-yellow-100 border-b-2']"
                class="text-xs px-2 py-1 rounded-full text-center whitespace-nowrap flex items-center gap-1 transition-colors">
                <PrinterIcon class="w-4 h-4" />
                <span>Checker</span>
              </button>
            </div>
          </div>

          <!-- Product Name -->
          <h4 class="font-semibold text-gray-900 dark:text-gray-100 text-lg">
            {{ item.name }}
            <span v-if="item.order_type === 'take_away'"
              class="text-xs px-2 py-1 rounded-full bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-100 text-center whitespace-nowrap">
              Take Away
            </span>
          </h4>
        </div>

        <div class="flex justify-between">
          <!-- Quantity Controls and Total -->
          <div v-if="item.payment_status == 1" class="flex flex-row items-center gap-3 pt-1">
            <div class="flex items-center bg-gray-200 dark:bg-dark-800 rounded-lg p-1">
              <button v-if="item.isEdit" @click="
                item.status === 'canceled'
                  ? $emit('reduce-qty-canceled', item)
                  : $emit('reduce-qty', item)
                " :id="'reduce-qty-' + item.id" class="p-1 text-gray-500 hover:text-blue-500 transition-colors">
                <MinusCircleIcon class="h-5 w-5" />
              </button>
              <input v-model="item.quantity" type="text"
                class="w-12 text-center bg-transparent font-bold text-gray-900 dark:text-gray-100"
                :class="{ 'cursor-not-allowed': !item.isEdit }" :disabled="!item.isEdit"
                @input="updateSubtotalPerItem(item)" oninput="this.value = this.value.replace(/\D/g, '')" />
              <button v-if="item.isEdit" @click="
                item.status === 'canceled'
                  ? $emit('add-qty-canceled', item)
                  : $emit('add-qty', item)
                " :id="'add-qty-' + item.id" class="p-1 text-gray-500 hover:text-blue-500 transition-colors">
                <PlusCircleIcon class="h-5 w-5" />
              </button>
            </div>
          </div>

          <!-- Price Info -->
          <div>
            <div class="flex flex-row sm:flex-row justify-end items-center gap-2 w-full">
              <template v-if="item.complimentary">
                <p class="font-medium text-gray-600 dark:text-gray-100 text-right text-sm">
                  {{ formatRupiah(0) }}
                </p>
              </template>
              <template v-else>
                <p v-if="item.discount_price > 0"
                  class="font-medium text-gray-400 dark:text-gray-400 text-right line-through text-xs">
                  {{ formatRupiah(item.price) }}
                </p>
                <p class="font-medium text-gray-600 dark:text-gray-100 text-right text-sm">
                  {{
                    formatRupiah(
                      item.discount_price > 0
                        ? parseFloat(item.price) - parseFloat(item.discount_price)
                        : item.price
                    )
                  }}
                </p>
              </template>
            </div>

            <p class="font-medium text-gray-900 dark:text-gray-100 w-full text-right">
              Total: {{ item.status === "canceled" ? "-" : ""
              }}{{ formatRupiah(item.total) }}
            </p>
          </div>
        </div>

        <div class="flex justify-between">
          <div class="flex flex-col gap-2 mt-2">
            <ToggleSwitch v-model="item.complimentary" id="Complimentary" class="h-4 w-8"
              @click="updateComplimentary(item)">
              <template #handle="{ checked }">
                <i :class="['!text-xs pi', { 'pi-check': checked, 'pi-times': !checked }]" />
              </template>
            </ToggleSwitch>
            <label v-if="item.complimentary" for="Complimentary" class="text-xs text-red-800 dark:text-red-100">*
              Complimentary</label>
          </div>
          <div v-if="item.isEdit && item.status !== 'canceled'" class="flex flex-col gap-2 mt-2">
            <div class="flex flex-wrap justify-center gap-2">
              <div class="flex items-center gap-2">
                <RadioButton v-model="item.order_type" inputId="order_type1" name="order_type" value="dine_in" />
                <label for="order_type1" class="dark:text-white">Dine In</label>
              </div>
              <div class="flex items-center gap-2">
                <RadioButton v-model="item.order_type" inputId="order_type2" name="order_type" value="take_away" />
                <label for="order_type2" class="dark:text-white">Take Away</label>
              </div>
            </div>

          </div>
        </div>

        <!-- Note Section -->
        <div class="mt-2">
          <!-- Note Input when editing -->
          <div v-if="item.isEdit" class="w-full">
            <input v-model="item.note" type="text" :placeholder="'Tambah catatan untuk ' + item.name"
              class="w-full px-3 py-2 bg-gray-50 dark:bg-dark-700 border border-gray-200 dark:border-dark-600 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
              @change="$emit('update-note', item)" />
          </div>

          <!-- Note Display when not editing -->
          <div v-else-if="item.note" class="text-sm text-gray-600 dark:text-gray-400">
            <p class="text-gray-700 dark:text-gray-300">
              <span class="font-medium">Catatan:</span> {{ item.note }}
            </p>
          </div>
        </div>
      </div>
      <!-- Delete Button -->
      <button v-if="item.isEdit && item.payment_status == 1" @click="$emit('remove-item', item)"
        :id="'remove-item-' + item.id"
        class="absolute -top-4 -right-4 p-1.5 text-red-500 hover:text-red-600 hover:bg-red-50 dark:hover:bg-red-900/50 rounded-lg transition-colors">
        <TrashIcon class="h-5 w-5" />
      </button>
      <button v-if="!item.isEdit && item.status != 'canceled'" label="Cancel" severity="danger"
        @click="$emit('cancel-order', item)"
        class="absolute -top-4 -right-4 p-1.5 text-red-500 hover:text-red-600 hover:bg-red-50 dark:hover:bg-red-900/50 rounded-lg transition-colors">
        <TrashIcon class="h-5 w-5" />
      </button>
    </div>
  </div>
</template>

<script>
  import { formatRupiah } from "@/helpers/formatRupiah";
import { formatTime } from "@/helpers/formatTime";
import {
    MinusCircleIcon,
    PlusCircleIcon,
    TrashIcon,
    PrinterIcon,
  } from "@heroicons/vue/24/solid";
  import { Button, RadioButton, ToggleSwitch } from "primevue";

  export default {
    name: "ListOrdered",
    components: {
      MinusCircleIcon,
      PlusCircleIcon,
      TrashIcon,
      Button,
      RadioButton,
      PrinterIcon,
      ToggleSwitch,
    },
    emits: [
      "add-qty",
      "add-qty-canceled",
      "reduce-qty",
      "update-subtotal",
      "update-complimentary",
      "update-note",
      "remove-item",
      "edit-note",
      "save-note",
      "cancel-order",
    ],
    props: {
      order_items: {
        type: Array,
        required: true,
      },
    },
    computed: {
      sortedOrderItems() {
        return [...this.order_items].sort((a, b) => b.id - a.id);
      },
      complimentaryAll() {
        console.log("complimentaryAll", this.order_items.every((item) => item.complimentary));
        console.log("complimentaryAll", this.order_items);
        return this.order_items.every((item) => item.complimentary);
      },
      isEditComplimentaryAll() {
        return this.order_items.every((item) => !item.isEdit);
      }
    },
    data() {
      return {
        modalShowPinComplimentary: false,
        selectedItem: null,
        localComplimentaryAll: false,
      };
    },
    watch: {
      order_items: {
        handler() {
          this.localComplimentaryAll = this.order_items.every((item) => item.complimentary);
        },
        deep: true,
        immediate: true,
      },
    },
    methods: {
      formatRupiah,
      formatTime,
      handleComplimentaryToggle() {
        this.updateComplimentary('all');
      },
      updateSubtotalPerItem(item) {
        this.$emit("update-subtotal", item);
      },
      updateComplimentary(item = 'all') {
        if (item === 'all') {
          // Invert the current local state
          // Create new array with updated complimentary state for all items
          const updatedItems = this.order_items.map(item => ({
            ...item,
            complimentary: this.localComplimentaryAll
          }));
          this.$emit("update-complimentary", updatedItems);
        } else {
          // For single item, just emit the item with toggled state
          this.$emit("update-complimentary", {
            ...item,
            complimentary: !item.complimentary
          });
        }
      },
    },
  };
</script>
